import { render, staticRenderFns } from "./exportDynamic.vue?vue&type=template&id=5d5064a7&scoped=true&"
import script from "./exportDynamic.vue?vue&type=script&lang=js&"
export * from "./exportDynamic.vue?vue&type=script&lang=js&"
import style0 from "./exportDynamic.vue?vue&type=style&index=0&id=5d5064a7&lang=scss&scoped=true&"
import style1 from "./exportDynamic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5064a7",
  null
  
)

export default component.exports